<script setup>
defineProps({
    dark: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <img
        v-if="!dark"
        v-bind="$attrs"
        src="/static/images/cbbc_logo.png"
    >
    <img
        v-if="dark"
        v-bind="$attrs"
        src="/static/images/cbbc_logo_dark.png"
    >
</template>
